import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

/** Staff only. Starts comparing the v2 catalog's home metrics with the canonical model and
 * returns at once; the summary is logged as "Home metrics v2 trial". */
export const runHomeMetricsV2Trial = {
  name: "runHomeMetricsV2Trial" as const,
  input: z.object({
    /** Leave out to run every merchant with canonical rows. */
    teamIds: z.array(zExt.objectId()).min(1).optional(),
    /** v2 queries in flight at once; 4 when left out. */
    concurrency: z.number().int().min(1).max(8).optional(),
  }),
  output: z.object({
    /** False when a run is already going on any server. */
    started: z.boolean(),
    /** The window compared, as YYYY-MM-DD. */
    periodKey: z.string(),
  }),
};
